import { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBarCustom from "../../components/NavBarCustom/NavBarCustom";
import { ScrollTop } from "../../components/ScrollTop/ScrollTop";
import AboutUs from "../../containers/AboutUs/AboutUs";
import Contact from "../../containers/Contact/Contact";
import Footer from "../../containers/Footer/Footer";
import TeamMembers from "../../containers/TeamMembers/TeamMembers";
import WhatWeDo from "../../containers/WhatWeDo/WhatWeDo";

import "../../App.css";
import "./TeamPage.css";

const TeamPage = (props) => {
	useEffect(() => {
		// Scroll to the top when the component mounts
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="team-page-container navbar-correction">
			{/* META TAGS */}
			<Helmet>
				<title>
					Conócenos: Agencia de Diseño Web Creativo y Cercano | DevAcuarela
				</title>
				<meta
					name="description"
					content="Somos tu aliado digital. Diseñamos webs personalizadas y te guiamos paso a paso para que tu negocio online brille."
				/>
			</Helmet>

			{/* PAGE CODE */}

			<div id="back-to-top-anchor"></div>

			<NavBarCustom actualRef={"team"} />
			<AboutUs />
			<TeamMembers />
			<WhatWeDo />
			<Contact />
			<Footer />

			<ScrollTop props={props} />
		</div>
	);
};

export default TeamPage;
